module.exports = __webpack_public_path__ + "kolko_kwadrat2.svg";